<template>
  <baseFrame>
    <div slot="affixInfo">
      <h4 class="ruleName">
        <span>名称：</span>
        <span>{{ $route.params.name }}</span>
      </h4>
      <div class="queryContainer">
        <div class="queryItem">
          <label>所属门店:</label>
          <lk-select  placeholder='请选择' filterable class="item" clearable
            v-model.trim='query.storeId'>
              <lk-option v-for="(item,index) in storeList" :key="index" :value='item.storeId'>{{ item.storeName }}</lk-option>
            </lk-select>
        </div>
        <div class="queryItem">
          <label>检测结果:</label>
          <lk-select  placeholder='请选择' class="item" clearable
            v-model.trim='query.checkResult'>
            <lk-option v-for="(item,index) in checkResultList" :key="index" :value="index">
              {{ item }}
            </lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
          <lk-button @click="clear">重置</lk-button>
        </div>
      </div>
    </div>
    <div slot="content">
      <div class="cardContainer" v-for="(item,index) in list" :key="index">
        <lk-card>
          <div slot="title" class="cardTitle">
            <h4>{{ item.storeName }}</h4>
            <span>
              <lk-button class="mr8" type='primary' size='small' @click="handleReUpload(item.id);" :disabled='!regenerateStatus'>上传</lk-button>
              <lk-button type='primary' size='small' @click="handleRegenerate(item.id);" :disabled='!regenerateStatus'>重新生成</lk-button>
            </span>
          </div>
          <div>
            <lk-form :label-width='120' label-position='right'>
              <lk-row :gutter='16' v-for="(tableData,index) in item.bizData" :key="index">
                <lk-col span='24'>
                  <lk-form-item :label='tableData.bizName+":"'>
                    <lk-table border :data='tableData.data' :columns='columns'></lk-table>
                  </lk-form-item>
                </lk-col>
              </lk-row>
            </lk-form>
          </div>
        </lk-card>
    <lk-modal title="数据重新生成规则设定" v-model="setRegenerate">
      <div class="holder">
        <label> 上传时间:</label>
        <timeStampDatePicker :options="optionsDisabled" class="datePicker" v-model="regenerateTime" placeholder="请选择需要重新生成数据的日期" ></timeStampDatePicker>
        <lk-poptip trigger='hover' word-wrap width="240" content="系统将按您选择的日期，根据数据直连规则，生成应在所选日期生成的日、周、月数据" placement="right-start" >
            <lk-icon type="md-help-circle" size=25 />
        </lk-poptip>
      </div>
      <div slot="footer">
        <lk-button @click="setRegenerate=false">取消</lk-button>
        <lk-button type='primary' @click="handleConfirmRegenerate" :loading='confirmLoading'>确定</lk-button>
      </div>
    </lk-modal>
      </div>
    </div>
  </baseFrame>
</template>
<script>
import baseFrame from '@/components/frame/BaseFrame.vue';
import timeStampDatePicker from '@/components/timeStampDatePicker.vue';
import dataDirect from '../../services/dataDirect';
import utils from '../../libs/utils';
import permission from '../../mixins/permission';

export default {
  name: 'dateCheckInfo',
  mixins: [permission],
  components: {
    baseFrame,
    timeStampDatePicker,
  },
  data() {
    return {
      optionsDisabled: {
        disabledDate(date) {
          return date && date.valueOf() > Date.now();
        },
      },
      regenerateStatus: false,
      regenerateTime: 0,
      regenerateId: null,
      confirmLoading: false,
      setRegenerate: false,
      storeList: [],
      checkResultList: {
        1: '正常',
        2: '异常',
        3: '必填数据缺失',
        4: '未执行',
      },
      statusList: {
        1: '文件生成中',
        2: '文件生成成功',
        3: '文件生成失败',
        4: '文件校验中',
        5: '文件校验成功',
        6: '文件校验失败',
        7: '文件上传中',
        8: '文件上传成功',
        9: '文件上传失败',
      },
      query: {},
      columns: [{
        title: '数据名称',
        key: 'fileName',
      },
      {
        title: '核验结果',
        key: 'checkResultName',
        render: (h, params) => {
          if (params.row.checkResult == 3) {
            return h('span', {
              style: {
                color: 'red',
              },
            }, this.checkResultList[params.row.checkResult]);
          }
          return h('span', this.checkResultList[params.row.checkResult]);
        },
      },
      {
        title: '上传状态',
        minWidth: 116,
        key: 'uploadStatus',
        render: (h, params) => h('span', {
          class: {
            error: params.row.status === 9,
          },
        }, this.statusList[params.row.status]),
      },
      {
        title: '操作',
        render: (h, params) => h('div', [
          h('lk-button', {
            props: {
              type: 'text',
              size: 'small',
              disabled: !this.permissionFunc('dataCheckInfoDownload'),
            },
            on: {
              click: () => {
                console.log(params.row);
                dataDirect.downloadData({ taskDetailId: params.row.id }).then((res) => {
                  utils.downLoadExcel(res, params.row.fileName, true);
                }).catch((err) => {
                  utils.handleError(err);
                });
              },
            },
          }, '查看'),
        ]),
      },
      ],
      list: [],
      count: 2,
    };
  },
  methods: {
    getStoreList() {
      const params = {
        ruleId: this.$route.params.ruleId,
      };
      dataDirect.getStoreListByRuleId(params).then((res) => {
        if (res.data.status === 200) {
          this.storeList = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleSearch() {
      this.getData(this.query);
    },
    clear() {
      this.query = {};
    },
    getData(query) {
      const params = query || {};
      params.taskId = this.$route.params.id;
      dataDirect.getTaskInfo(params).then((res) => {
        if (res.data.status === 200) {
          const { data } = res.data;
          data.forEach((biz) => {
            biz.bizData.forEach((item) => {
              item.data.forEach((tableItem) => {
                tableItem.checkResultName = this.checkResultList[tableItem.checkResult];
              });
            });
          });
          this.list = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleRegenerate(id) {
      this.setRegenerate = true;
      this.regenerateId = id;
      this.regenerateTime = (new Date()).getTime();
    },
    handleReUpload(id) {
      this.checkAndUploadLoading = true;
      const taskRecordIdList = [];
      if (this.list && !utils.isEmpty(id)) {
        this.list.forEach((item) => {
          if (id == item.id) {
            console.log(item, 'item');
            if (item.bizData && item.bizData.length > 0) {
              item.bizData.forEach((elem) => {
                elem.data.forEach((item) => {
                  taskRecordIdList.push(item.id);
                })
              });
            }
          }
        });
      }
      dataDirect.uploadDataAndCheck({ storeId: id, ruleId: this.$route.params.ruleId, taskRecordIdList }).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('处理成功');
          this.getData();
        } else if (res.data.status === 100001) {
          this.errContent = res.data.error;
          this.errModal = true;
        } else {
          this.$Message.error(res.data.error);
        }
        this.checkAndUploadLoading = false;
      }).catch((err) => {
        utils.handleError(err);
        this.checkAndUploadLoading = false;
      });
    },
    handleConfirmRegenerate() {
      this.confirmLoading = true;
      const taskRecordIdList = [];
      if (this.list && !utils.isEmpty(this.regenerateId)) {
        this.list.forEach((item) => {
          if (this.regenerateId == item.id) {
            console.log(item, 'item');
            if (item.bizData && item.bizData.length > 0) {
              item.bizData.forEach((elem) => {
                taskRecordIdList.push(elem.data[0].id);
              });
            }
          }
        });
      }
      dataDirect.regenerateData({
        storeId: this.regenerateId, date: this.regenerateTime, ruleId: this.$route.params.ruleId, taskRecordIdList,
      }).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('重新生成成功');
          this.getData();
          this.setRegenerate = false;
        } else {
          this.$Message.error(res.data.error);
        }
        this.confirmLoading = false;
      }).catch((err) => {
        utils.handleError(err);
        this.confirmLoading = false;
      });
    },
  },
  created() {
    this.getData();
    this.getStoreList();
    this.regenerateStatus = this.permissionFunc('dataCheckRegenerate');
  },
};
</script>
<style lang="less" scoped>
  .ruleName {
    background: #fff;
    padding-left: 32px;
    padding-bottom: 8px
  }
  .queryContainer {
    background: #fff;
    padding-left: 32px
  }
  .cardTitle {
    display: flex;
    justify-content: space-between;
    height: 32px;
    align-items: center // padding: 16px 0
  }
  .cardContainer {
    margin-bottom: 16px
  }
  .holder{
    display: flex;
    padding:  0 32px;
    justify-content:center;
    align-items: center;
    .datePicker{
      width: 300px;
      margin-left: 16px
    }
  }
</style>
